<template>
  <div :id="data.id" class="bg-gray-lighten3 pb-20 pt-10 md:pb-28 md:pt-14">
    <div class="container">
      <div
        v-lazy-background="backgroundImage"
        class="flex min-h-[535px] flex-col justify-between rounded-lg bg-slate bg-cover bg-center bg-no-repeat p-6 md:min-h-[672px] md:p-16"
      >
        <UiSectionTitle
          v-if="data.title"
          :title="data.title"
          class="title mb-2 mb-[150px] mb-auto whitespace-pre-line text-3xl uppercase leading-[1em] text-white md:text-[3.5rem]"
        />

        <div
          v-if="data.items && data.items.length"
          class="mt-auto flex flex-col gap-2 lg:flex-row"
        >
          <UiLink
            v-for="(item, i) in data.items"
            :key="i"
            :to="item.link"
            :target="item.target"
            class="lg:max-w-auto title group flex w-[303px] items-center rounded-xl bg-white p-4 text-sm leading-none tracking-[0.12em] text-slate hover:text-blue lg:w-[208px] lg:flex-col lg:items-start"
          >
            <div
              v-if="item.icon"
              class="pointer-events-none mr-[22px] flex-shrink-0 flex-grow-0 rounded-full bg-slate p-4 transition-colors group-hover:bg-blue md:mb-4"
            >
              <object class="h-6 w-6" :data="getImage(item.icon)"></object>
            </div>

            <span
              class="inline-flex flex-grow items-center justify-between uppercase md:w-full"
            >
              <span v-html="item.name" />

              <span class="ml-2 h-4 w-4">
                <UiIcon icon="arrowRightBold" container-size></UiIcon>
              </span>
            </span>
          </UiLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(
    isDesktop.value
      ? props.data.image
      : (props.data.imageMobile ?? props.data.image),
  ),
);

const getImage = (src: string) => getAssetUrl(src) ?? undefined;
</script>
